<h3-layer-view-settings [viewModeOptions]="viewModeOptions">
  <h3-point-cloud-layer-view-settings-popover>
  </h3-point-cloud-layer-view-settings-popover>
</h3-layer-view-settings>
